var _radialGradient, _path, _linearGradient, _circle, _linearGradient2, _path2, _radialGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _circle2, _linearGradient5, _circle3, _linearGradient6, _circle4, _linearGradient7, _circle5, _linearGradient8, _circle6, _linearGradient9, _circle7, _linearGradient0, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Electrical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 35.831,
    cy: 35.643,
    r: 10.082,
    gradientTransform: "matrix(.9938 0 0 1 .184 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#787f85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#7a8187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#90989f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#9da5ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#a1aab3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M29.8,39H7c-2.2,0-4-1.8-4-4v0c0-2.2,1.8-4,4-4h22.8V39z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 19.209,
    x2: 22.491,
    y1: -605.05,
    y2: -608.332,
    gradientTransform: "scale(1 -1) rotate(-45 704.401 -304.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#0e5fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#135796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 35,
    r: 2,
    fill: "url(#SVGID_2_)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 35.544,
    x2: 48.074,
    y1: -579.59,
    y2: -592.119,
    gradientTransform: "scale(1 -1) rotate(-45 704.401 -304.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M39.7,38.7c-2.1,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7c0.5,0,2.5,0,4.6,0c0.5,0,0.8-0.5,0.6-1 c-0.6-1-1.5-2-2.6-2.7c-3.3-2.2-7.7-2.1-10.7,0.4c-4.5,3.6-4.5,10.4,0,14c3.1,2.5,7.5,2.6,10.7,0.4c1.1-0.8,2-1.7,2.6-2.7 c0.3-0.4-0.1-1-0.6-1C42.2,38.7,40.2,38.7,39.7,38.7z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 22.675,
    cy: -600.102,
    r: 5.74,
    gradientTransform: "translate(0 608.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e757b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4e52"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M26.9,6.9C26.9,5.3,25.6,4,24,4s-2.9,1.3-2.9,2.9c0,0,0,0.7,0,1.1h5.7C26.9,7.6,26.9,6.9,26.9,6.9z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    x1: 22.223,
    x2: 26.939,
    y1: -586.804,
    y2: -601.557,
    gradientTransform: "translate(0 608.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M26.9,8.6V8h-5.7v0.6c0,1.8-2.9,4.2-2.9,7.5c0,3.1,2.6,5.7,5.7,5.7s5.7-2.6,5.7-5.7 C29.7,12.7,26.9,10.4,26.9,8.6z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    x1: 15,
    x2: 15,
    y1: 4.903,
    y2: 24.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 17,
    r: 1,
    fill: "url(#SVGID_6_)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    x1: 33.028,
    x2: 33.028,
    y1: 4.903,
    y2: 24.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 17,
    r: 1,
    fill: "url(#SVGID_7_)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    x1: 31,
    x2: 31,
    y1: 4.903,
    y2: 24.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 11,
    r: 1,
    fill: "url(#SVGID_8_)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    x1: 17,
    x2: 17,
    y1: 4.903,
    y2: 24.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 1,
    fill: "url(#SVGID_9_)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    x1: 18,
    x2: 18,
    y1: 4.903,
    y2: 24.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 23,
    r: 1,
    fill: "url(#SVGID_10_)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    x1: 30,
    x2: 30,
    y1: 4.903,
    y2: 24.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 23,
    r: 1,
    fill: "url(#SVGID_11_)"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    x1: 24,
    x2: 24,
    y1: 4.903,
    y2: 24.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25,
    r: 1,
    fill: "url(#SVGID_12_)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Electrical);
export default __webpack_public_path__ + "static/media/icons8-electrical.caf82b45c5f2accc39acea49fa45cea3.svg";
export { ForwardRef as ReactComponent };